import { LINEAR, transition } from './transition';
export var scrollToTop = function (duration) {
    if (duration === void 0) { duration = 1000; }
    var body = document.getElementsByTagName('body')[0];
    var html = document.getElementsByTagName('html')[0];
    if (body) {
        transition(body, { scrollTop: 0 }, LINEAR, duration);
    }
    if (html) {
        transition(html, { scrollTop: 0 }, LINEAR, duration);
    }
};
